<template>
    <span class="infoParent" style="position: relative;">
        <span role="button" class="material-symbols-outlined" @click.stop="displayInfos()">user_attributes</span>
        <div v-if="active" class="infoBox">
            <table class="table">
                <tr v-if="employee">
                    <td>{{ $trans.get('__JSON__.Team') }}</td><td>{{ employee.team.name }}</td>
                </tr>
                <tr v-if="employee">
                    <td>{{ $trans.get('__JSON__.Employer') }}</td><td>{{ employee.employer.name }}</td>
                </tr>
                <tr v-if="employee">
                    <td>{{ $trans.get('__JSON__.Employeenumber') }}</td><td>{{ employee.employeenumber }}</td>
                </tr>
                <tr v-if="vacationdata" class="text-center">
                    <td class="fw-bold">{{ $trans.get('__JSON__.Vacation') }}</td><td class="fw-bold">{{ $trans.get('__JSON__.Days') }}</td>
                </tr>
                <tr v-if="vacationdata">
                    <td>{{ $trans.get('__JSON__.Days available') }}</td><td class="text-end">{{ vacationdata.daysLeft }}</td>
                </tr>
                <tr v-if="vacationdata">
                    <td>{{ $trans.get('__JSON__.Used vacation days') }}</td><td class="text-end">{{ vacationdata.daysUsed * -1 }}</td>
                </tr>
                <tr v-if="vacationdata">
                    <td>{{ $trans.get('__JSON__.Requested vacations') }}</td><td class="text-end">{{ vacationdata.daysRequested }}</td>
                </tr>
                <tr v-if="vacationdata">
                    <td>{{ $trans.get('__JSON__.Vacation granted') }}</td><td class="text-end">{{ vacationdata.daysGranted }}</td>
                </tr>
            </table>
            <button @click.stop="hideInfos()" class="btn btn-secondary btn-sm float-end">OK</button>
        </div>
    </span>
</template>

<script>
import axios from "axios";

export default {
    setup() {
    },
    name: "EmployeeInfo",
    created() {
    },
    props: {
        employee_id: Number,
    },
    data() {
        return {
            active: false,
            employee: null,
            vacationdata: null
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        displayInfos() {
            $(".tooltip").css('display', 'none');
            this.fetchEmployee();
            this.fetchVacationData();
            this.active = !this.active;
        },
        hideInfos() {
            $(".tooltip").css('display', 'none');
            this.active = false;
        },
        fetchEmployee() {
            axios
                .get("/api/employees/" + this.employee_id, {})
                .then((resp) => {
                    console.log(resp.data);
                    this.employee = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchVacationData() {
            axios
                .get("/api/employees/" + this.employee_id + '/vacationdata')
                .then((resp) => {
                    console.log("VacationData", resp.data);
                    this.vacationdata = resp.data;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });

        },
    }
};
</script>

<style scoped>
.infoParent {
    position: relative;
}

.infoBox {
    position: absolute;
    top: -20px;
    left: 100%;
    width: 30vw;
    z-index: 1000;
    border-radius: 1rem;
    border-style: solid;
    border-color: lightgray;
    background-color: white;
    padding: 0.5rem;

}
</style>
